<template>
    <div class="container mescroll-touch">
        <img src="../../assets/images/downloadtop.png" class="img" />
        <!-- <img src="../../assets/images/topguanggao.png" class="guanggaoimg" /> -->
        <div class="main">
            <div>请扫码查看，按需下载：</div>
            <div class="huiyisaoma">
                <img src="../../assets/images/richengqr.png" class="huiyiqrimg" />
                <!-- <div class="perplebold">会议通知<br />（盖章版）</div> -->
            </div>
            <!-- <div class="perplebold" v-clipboard:copy="'https://stc.tv-conf.com/custom/img/meetinginvite.pdf'"
                v-clipboard:success="copy1">
                会议通知（盖章版）</div> -->
            <!-- <div class="perplebold" v-clipboard:copy="'http://jtapi.bendibao.com/ditie/inc/sh/xianluda.gif?2025050816'"
                v-clipboard:success="copy2">
                上海轨道交通运营图</div> -->
            <input id="input" style="display: none;" />
        </div>
        <floatback></floatback>
    </div>
</template>
<!-- https://stc.tv-conf.com/custom/img/meetinginvite.pdf -->
<!-- http://jtapi.bendibao.com/ditie/inc/sh/xianluda.gif?2025050816 -->
<script>
import floatback from './floatback.vue';
import mixin from '../../common/mixin/mixins'
export default {
    name: 'timeline',
    data() {
        return {
        }
    },
    mixins: [mixin],
    components: {
        floatback
    },
    created() {
        this.initacmedShare();
        document.title = "ACMED第一届学术年会";
    },
    methods: {
        copy1(e) {
            console.log("copy arguments e:", e);
            alert("复制成功!");
        },
        copy2(e) {
            console.log("copy arguments e:", e);
            alert("复制成功!");
        },
    }
}
</script>

<style lang="scss" scoped>
.container {
    height: 100%;
    width: 100%;
    // background: rgb(228, 236, 255);
}

.img {
    display: block;
    width: 100%;
    margin-bottom: .2rem
}

.zuzhititleimg {
    display: block;
    width: 55%;
    margin: auto;
    margin-bottom: .2rem
}

.zuzhititleimg1 {
    display: block;
    width: 55%;
    margin: .5rem auto .2rem auto;
}

.guanggaoimg {
    display: block;
    width: 92%;
    margin: 0.5rem auto;
}

.modelline {
    border-bottom: 1px solid rgb(179, 178, 255);
    border-bottom-left-radius: 50rem;
}

.modeltitle {
    background: #b3b2ff;
    width: 37%;
    display: flex;
    flex-direction: row;
    padding: 0.1rem;
    border-radius: 30px 50px 0px 30px;
}

.modeltitleimg {
    display: block;
    width: 15%;
}

.modeltitletext {
    margin-left: 0.2rem;
    color: #fff;
    font-weight: bold;
    // font-size: 16px;
}

.model {
    width: 92%;
    margin: auto;
    margin-top: 0.5rem;
}

.model1 {
    width: 92%;
    margin: auto;
    margin-top: 0.5rem;
    padding-bottom: 1rem;
}

.center {
    text-align: center;
}

.preple {
    color: rgb(177, 172, 255);
}

.neirong {
    margin-top: .3rem
}

.ziti {
    font-size: .37rem;
}

.neirong {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
}

.name {
    width: 50%;
    // text-align: center;
    font-size: .37rem;
    // margin: 0.1rem 0;
}

.name1 {
    width: 50%;
    text-align: right;
    font-size: .37rem;
    // margin: 0.1rem 0;
}

.perplebold {
    color: #8483d1;
    font-weight: bold;
}

.wait {
    text-align: center;
    color: rgb(111, 86, 250);
    font-weight: bold;
    font-size: .55rem;
    margin-top: 20%;
}

.main {
    width: 85%;
    margin: 1rem auto;

    div {
        margin: .3rem 0;
    }
}

.huiyisaoma {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 0.8rem !important;
    box-sizing: border-box;
    padding: 0.4rem;

    .huiyiqrimg {
        display: block;
        width: 50%;
    }

    div {
        width: 45%;
        text-align: center;
        font-size: 0.5rem;
    }
}
</style>